// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import AutoSubmitFormController from "./auto_submit_form_controller"
application.register("auto-submit-form", AutoSubmitFormController)

import AutosizeController from "./autosize_controller"
application.register("autosize", AutosizeController)

import CheckoutController from "./checkout_controller"
application.register("checkout", CheckoutController)

import DebugPanelController from "./debug_panel_controller"
application.register("debug-panel", DebugPanelController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DropdownTriggerController from "./dropdown_trigger_controller"
application.register("dropdown-trigger", DropdownTriggerController)

import FilterPanelController from "./filter_panel_controller"
application.register("filter-panel", FilterPanelController)

import FlyoutController from "./flyout_controller"
application.register("flyout", FlyoutController)

import FlyoutTriggerController from "./flyout_trigger_controller"
application.register("flyout-trigger", FlyoutTriggerController)

import IconsController from "./icons_controller"
application.register("icons", IconsController)

import InfoboxController from "./infobox_controller"
application.register("infobox", InfoboxController)

import InputToggleController from "./input-toggle_controller"
application.register("input-toggle", InputToggleController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import PhoneFieldController from "./phone_field_controller"
application.register("phone-field", PhoneFieldController)

import PopupController from "./popup_controller"
application.register("popup", PopupController)

import QuantityStepperController from "./quantity_stepper_controller"
application.register("quantity-stepper", QuantityStepperController)

import RecipeIngredientsController from "./recipe_ingredients_controller"
application.register("recipe-ingredients", RecipeIngredientsController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import SearchInputController from "./search_input_controller"
application.register("search-input", SearchInputController)

import StockAlertButtonController from "./stock_alert_button_controller"
application.register("stock-alert-button", StockAlertButtonController)

import StockAlertController from "./stock_alert_controller"
application.register("stock-alert", StockAlertController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import TextExpandController from "./text_expand_controller"
application.register("text-expand", TextExpandController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)
